// extracted by mini-css-extract-plugin
export default {"changeLink":"XN-z","disabled":"YN-z","inline":"ZN-z"};